import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  useAdminAuth,
  UserRole,
} from "@jambushrushti/contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";
import { getAdminSession } from "@jambushrushti/services/adminAuth";

interface ProtectedAdminRouteProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
}

const ADMIN_ALLOWED_ROLES: UserRole[] = ["superadmin", "admin"];

export function ProtectedAdminRoute({
  children,
  allowedRoles = ADMIN_ALLOWED_ROLES,
}: ProtectedAdminRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAdminAuth();
  const cmsSession = getAdminSession();

  if (isLoading || (isAuthenticated && !user)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (
    !isAuthenticated ||
    !cmsSession?.accessToken ||
    !cmsSession.can_access_cms
  ) {
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
